import { render, staticRenderFns } from "./root.vue?vue&type=template&id=47210b7c&scoped=true"
import script from "./root.vue?vue&type=script&lang=js"
export * from "./root.vue?vue&type=script&lang=js"
import style0 from "./root.vue?vue&type=style&index=0&id=47210b7c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47210b7c",
  null
  
)

export default component.exports